import React, { useState } from 'react';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import AddShiftModal from '../AddShiftModal/AddShiftModal';

const headerStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '20px',
  backgroundColor: '#0B1F4B',
  padding: '10px',
  borderRadius: '5px',
};
const weekSelectorStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
};
const buttonStyle = {
  backgroundColor: '#0056b3',
  color: 'white',
  border: 'none',
  borderRadius: '5px',
  padding: '10px 15px',
  cursor: 'pointer',
  fontWeight: 'bold',
  display: 'flex',
  alignItems: 'center',
  gap: '5px',
};
const selectStyle = {
  backgroundColor: '#0B1F4B',
  color: 'white',
  border: 'none',
  borderRadius: '5px',
  padding: '5px',
  fontWeight: 'bold',
  cursor: 'pointer',
};

const Header = ({
  weekLabel,
  showToday,
  onToday,
  onThisWeek,
  onPrint,
  onNextWeek,
  onPreviousWeek,
  onSelectWeek,
  currentWeek,
}) => {
  const printStyles = `
    @media print {
      @page { size: A4 landscape; margin: 10mm; }
      body { margin: 0; padding: 0; }
    }
  `;

  const weekOptions = Array.from({ length: 52 }, (_, i) => i + 1);

  const [showModal, setShowModal] = useState(false);

  return (
    <div style={headerStyle}>
      <style>{printStyles}</style>
      <div style={weekSelectorStyle}>
        <button style={buttonStyle} onClick={onPreviousWeek}>
          <IoIosArrowBack size={30} />
        </button>

        <div style={{ ...buttonStyle, display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span>{weekLabel}</span>
          <select
            style={selectStyle}
            value={currentWeek}
            onChange={(e) => onSelectWeek(Number(e.target.value))}
          >
            {weekOptions.map((week) => (
              <option key={week} value={week}>
                Semana {week}
              </option>
            ))}
          </select>
        </div>

        <button style={buttonStyle} onClick={onNextWeek}>
          <IoIosArrowForward size={30} />
        </button>
      </div>
      <div style={weekSelectorStyle}>
        {showToday ? (
          <button style={buttonStyle} onClick={onToday}>
            Hoje
          </button>
        ) : (
          <button style={buttonStyle} onClick={onThisWeek}>
            Esta Semana
          </button>
        )}
        <button style={buttonStyle}>
          <span>🔄</span> Limpar seleção
        </button>
        <button style={buttonStyle}>
          <span>➕</span> Filtros
        </button>
        <>
          <button onClick={() => setShowModal(true)} style={buttonStyle}>➕</button>
          <AddShiftModal show={showModal} handleClose={() => setShowModal(false)} />
        </>
        <button style={buttonStyle} onClick={onPrint}>
          <span>🖨️</span> Print
        </button>
        <button style={buttonStyle}>
          <span>📤</span> Publicar
        </button>
      </div>
    </div>
  );
};

export default Header;
